module.exports = __webpack_public_path__ + "img/hybrid.3c994d29.svg";